import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import {
  makeStyles,
  CircularProgress,
  FormControl,
  Select,
  FormHelperText,
  InputLabel,
} from '@material-ui/core';

import { fetchCities, setCity } from 'app/store/slices/forms';
import { useSelector, useDispatch } from 'react-redux';
import styles from './styles';
import { Field } from 'formik';

const useStyles = makeStyles(styles);

function SearchCounty({ formikBag, uf, label, canEdit, name = 'cdMunicipio', shrink }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { values } = formikBag;

  const [loadingCity, setLoadingCity] = useState(false);

  const cities = useSelector(state => state.forms.cities);

  useEffect(() => {
    const init = async () => {
      setLoadingCity(true);
      if (cities.length === 0) {
        await dispatch(fetchCities(uf));
      }
      if (values?.municipio) {
        dispatch(setCity(values.municipio));
      }
      setLoadingCity(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, uf, values.cdMunicipio]);

  const onChangeMunicipio = async value => {
    const found = _.find(cities, [name, Number(value)]);
    if (found) {
      formikBag.setFieldValue(name, value);
      formikBag.setFieldValue('municipio', found);
    }
    await dispatch(setCity(found));
  };

  return (
    <Field name="municipio">
      {({ field, form: { errors } }) => {
        return (
          <div className={classes.positionRelative}>
            {loadingCity && (
              <div className={classes.loadingUser}>
                <CircularProgress size={20} />
              </div>
            )}
            <FormControl
              disabled={!canEdit}
              variant="filled"
              margin="dense"
              fullWidth
              error={!!errors.cdMunicipio}
            >
              <InputLabel htmlFor="cdMunicipio" shrink={shrink ? shrink : false}>
                {label}
              </InputLabel>
              <Field
                name="cdMunicipio"
                id="cdMunicipio"
                native
                as={Select}
                onChange={e => onChangeMunicipio(e.target.value)}
              >
                <option aria-label="None" value="">
                  Selecione
                </option>
                {cities.map((c, index) => {
                  return (
                    <option key={`type-${index}`} value={c.cdMunicipio}>
                      {c.nmMunicipio} - {c.uf.sgUf}
                    </option>
                  );
                })}
              </Field>
              {errors.cdMunicipio ? <FormHelperText>{errors.cdMunicipio}</FormHelperText> : null}
            </FormControl>
          </div>
        );
      }}
    </Field>
  );
}

export default SearchCounty;
